import React from "react";
import PageHero from "@/components/PageHero";
import LeadForm from "@/components/LeadForm";
import { Mail, Phone, MapPin, MessageCircle, Linkedin } from "lucide-react";
import { CONTACT } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { openWhatsApp } from "@/components/WhatsAppFloat";

export default function Contact() {
  const { t } = useT();
  return (
    <div data-testid="page-contact">
      <PageHero
        eyebrow={t("nav.contact")}
        title={
          <>
            {t("page.contact.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("page.contact.title.b")}</span>
          </>
        }
        subtitle={t("page.contact.sub")}
      />

      <section className="relative pb-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="zp-card p-8">
              <div className="zp-label mb-2">{t("page.contact.reach")}</div>
              <h3 className="font-display text-2xl tracking-tight">
                {t("page.contact.hub")}
              </h3>
              <div className="mt-6 space-y-4 text-sm">
                <a data-testid="contact-email" href={`mailto:${CONTACT.email}`} className="flex items-start gap-3 text-[color:var(--zp-navy)] hover:text-[color:var(--zp-cyan-3)]">
                  <Mail size={16} className="text-[color:var(--zp-cyan-3)] mt-0.5" />
                  <div>
                    <div className="zp-label">{t("page.contact.email")}</div>
                    <div>{CONTACT.email}</div>
                  </div>
                </a>
                <a data-testid="contact-phone" href={`tel:${CONTACT.phone}`} className="flex items-start gap-3 text-[color:var(--zp-navy)] hover:text-[color:var(--zp-cyan-3)]">
                  <Phone size={16} className="text-[color:var(--zp-cyan-3)] mt-0.5" />
                  <div>
                    <div className="zp-label">{t("page.contact.phone")}</div>
                    <div>{CONTACT.phone}</div>
                  </div>
                </a>
                <button
                  data-testid="contact-whatsapp"
                  onClick={() => openWhatsApp()}
                  className="flex items-start gap-3 text-[color:var(--zp-navy)] hover:text-[color:var(--zp-cyan-3)] text-left w-full"
                >
                  <MessageCircle size={16} className="text-emerald-500 mt-0.5" />
                  <div>
                    <div className="zp-label">{t("page.contact.wa")}</div>
                    <div>{CONTACT.phone}</div>
                  </div>
                </button>
                <div className="flex items-start gap-3 text-[color:var(--zp-navy)]">
                  <MapPin size={16} className="text-[color:var(--zp-cyan-3)] mt-0.5" />
                  <div>
                    <div className="zp-label">{t("page.contact.office")}</div>
                    <div>{CONTACT.address}</div>
                  </div>
                </div>
                <a data-testid="contact-linkedin" href={CONTACT.linkedin} target="_blank" rel="noreferrer" className="flex items-start gap-3 text-[color:var(--zp-navy)] hover:text-[color:var(--zp-cyan-3)]">
                  <Linkedin size={16} className="text-[color:var(--zp-cyan-3)] mt-0.5" />
                  <div>
                    <div className="zp-label">{t("page.contact.linkedin")}</div>
                    <div>{t("page.contact.founder")}</div>
                  </div>
                </a>
              </div>
            </div>

            <div className="mt-5 zp-card p-8">
              <div className="zp-label mb-2">{t("page.contact.brands")}</div>
              <ul className="text-[color:var(--zp-navy)] space-y-1.5 text-sm">
                {CONTACT.brands.map((b) => (
                  <li key={b.url}>
                    <a href={b.url} target="_blank" rel="noreferrer" className="hover:text-[color:var(--zp-cyan-3)]">
                      {b.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7">
            <LeadForm source="contact" title={t("page.contact.formTitle")} />
          </div>
        </div>
      </section>
    </div>
  );
}
